import { elegir } from '../ui/layout-variant.tsx';
import { InicioMobile } from './Inicio.mobile.tsx';
import { InicioDesktop } from './Inicio.desktop.tsx';

export default elegir(InicioMobile, InicioDesktop);
